import React, { Component } from 'react';
import {
    Form,
    Select,
    TreeSelect,
    InputNumber,
    Switch,
    Radio,
    message,
    Button,
    Upload,
    Icon,
    Rate,
    Checkbox,
    Row,
    Col,
    Layout,
    Breadcrumb,
    Cascader,
    Input
} from 'antd';
import Subside from '../../page/Home/Subside';
import subapi from '../subapi'
import './index.css';

const { TreeNode } = TreeSelect;
const { Content } = Layout;
const { TextArea } = Input;
const { SHOW_PARENT } = TreeSelect;
const { Option } = Select;


class releaseDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            daten:[],
        }
    }
    componentDidMount(){
       this.versionDetails()
    }
    versionDetails(){
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        let params={
            access_token:token,
            id:this.props.match.params.id
        }
        subapi.versionDetails(params).then(res=>{
            console.log(res.content)
            this.setState({daten:res.content})
        })
    }
    jump = () => {
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        this.props.history.push(`/EditionManagement?access_token=${token}`);
    }

    particulars=(data)=>{
        console.log(data)
        let mold = "";
        let edition = "";
        if(data.app === 'cgj' && data.type === 1){
            mold = "彩管家Android"
        }else if(data.app === 'cgj' && data.type === 2){
            mold = "彩管家ios"
        }else if(data.app === 'czy' && data.type === 2){
            mold = "彩之云ios"
        }else if(data.app === 'czy' && data.type === 1){
            mold = "彩之云Android"
        }else if (data.app === "wyt" && data.type === 2) {
            mold.push("物业通","ios")
        } else if (data.app === "wyt" && data.type === 1) {
            mold.push("物业通","Android")
        }
        if(data.state === 0){
            edition="待发布"
        }else if(data.state === 1){
            edition="灰度发布"
        }else if(data.state === 2){
            edition="当前版本"
        }else if(data.state === 3){
            edition="历史版本"
        }

        return(
            <div className="detail">
                <div>App类型：{mold}</div>
                <div>版本号：{data.version}<span className="edition">{edition}</span></div>
                <div>下载地址：{data.download_url}</div>
                <div>文件大小：{data.size}</div>
                <div>发布时间：{data.publish_at}</div>
                <div>创建时间：{data.create_at}</div>
                <div>发布内容：</div>
                <div style={{ textIndent: '2em'}}>{data.func}</div>
                <div>修复的BUG：</div>
                <div style={{ textIndent: '2em'}}>{data.bug}</div>
                <div>支持最低版本：{data.min_version}</div>
                <div>灰度范围：{data.state===2? '全量':'灰度'}</div>
                {data.state===1?<div>
                    {JSON.parse(data.scale_content||'[]').map(v=>{
                        return <div key={v.detail}>组织架构：{v.name}</div>
                    })}

                </div>:''}
            </div>
        )
    }
    render() {
        console.log(this.state.daten)
        const {daten} = this.state
        return (
            <div style={{ width: '100%', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                <Layout style={{ height: '100%' }}>
                    <div style={{ display: 'flex' }}>
                        <Content style={{ backgroundColor: 'rgb(242, 244, 245)', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ width: '100%', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                                    <div style={{ padding: '14px 16px', borderBottom: '1px solid rgb(204, 204, 204)', background: "#fff" }}>
                                        <Breadcrumb>
                                            <Breadcrumb.Item>
                                                <a onClick={this.jump}>发版管理</a>
                                            </Breadcrumb.Item>
                                            <Breadcrumb.Item>
                                                发版管理详情
                                            </Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>
                                    <Layout id="project_management">
                                    <Content className="content">
                                        <div style={{ display: 'flex',justifyContent:"center"}}>
                                          
                                            {this.particulars(this.state.daten)}
                                            {/* <div>{content.app}</div> */}
                                        </div>
                                    </Content>
                                    </Layout>
                                </div>
                            </div>
                        </Content>
                    </div>
                </Layout>
            </div>
        )
    }

}
export default releaseDetails